// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c236b0ab","577":"26ac71f2","851":"54bf5e0e"}[chunkId] + ".chunk.js";
};